/**
 * Lintier size guides — one delegated handler for every guide dialog
 * (ring and necklace). A trigger carries data-sg-open="<dialog id>";
 * inside a dialog.lintier-sg, [data-sg-tab] switches panels and
 * [data-sg-close] or a tap on the scrim closes it.
 */
(function () {
  function open(dialog) {
    dialog.showModal();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dialog.classList.add('lintier-sg--open');
      });
    });
  }

  function close(dialog) {
    dialog.classList.remove('lintier-sg--open');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      dialog.close();
      return;
    }
    var done = function (event) {
      if (event.target !== dialog || event.propertyName !== 'transform') return;
      dialog.removeEventListener('transitionend', done);
      dialog.close();
    };
    dialog.addEventListener('transitionend', done);
  }

  function selectTab(dialog, name) {
    dialog.querySelectorAll('[data-sg-tab]').forEach(function (tab) {
      tab.setAttribute('aria-selected', tab.getAttribute('data-sg-tab') === name ? 'true' : 'false');
    });
    dialog.querySelectorAll('[data-sg-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-sg-panel') !== name;
    });
    var body = dialog.querySelector('[data-sg-body]');
    if (body) body.scrollTop = 0;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var opener = event.target.closest('[data-sg-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-sg-open'));
      if (target) open(target);
      return;
    }

    var tab = event.target.closest('.lintier-sg [data-sg-tab]');
    if (tab) {
      selectTab(tab.closest('dialog.lintier-sg'), tab.getAttribute('data-sg-tab'));
      return;
    }

    var closer = event.target.closest('[data-sg-close]');
    if (closer) {
      close(closer.closest('dialog.lintier-sg'));
      return;
    }

    /* click on the scrim: the dialog itself is the event target */
    if (event.target.matches('dialog.lintier-sg[open]')) {
      close(event.target);
    }
  });

  /* Escape: intercept the native cancel so the exit animates too */
  document.addEventListener('cancel', function (event) {
    var dialog = event.target;
    if (dialog instanceof HTMLElement && dialog.matches('dialog.lintier-sg')) {
      event.preventDefault();
      close(dialog);
    }
  }, true);
})();
